<script setup>
    import { ref, computed, onMounted } from 'vue'
    import {useToast} from 'vue-toast-notification'
    import 'vue-toast-notification/dist/theme-sugar.css'
    import axios from 'axios'
    import Loading from '@/components/Loading.vue'
    import PromotionItem from '@/components/PromotionItem.vue'

    const toast = useToast()

    const currentLocation = ref(null)
    const listPromotions = ref([])
    const isEmpty = ref(false)

    function requestGeolocation() {
      fetchPromotions()
      /*if (navigator.geolocation) {
        isEmpty.value = false
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const { latitude, longitude } = position.coords
            currentLocation.value = { latitude, longitude }
            fetchPromotions()
          },
          (error) => {
            let error_message = ''
            switch (error.code) {
              case error.PERMISSION_DENIED:
                error_message = 'Permiso denegado para acceder a la ubicación.'
                break
              case error.POSITION_UNAVAILABLE:
                error_message = 'Información de ubicación no disponible.'
                break
              case error.TIMEOUT:
                error_message = 'Tiempo de espera agotado al intentar obtener la ubicación.'
                break
              default:
                error_message = 'Error al obtener la ubicación: ' + error.message
            }

            toast.open({
              message: error_message,
              type: 'default',
              position: 'bottom'
            })
          }
        );
      } else {
        toast.open({
          message: 'La geolocalización no está soportada en este navegador.',
          type: 'default',
          position: 'bottom'
        })
      }*/
    }

    async function fetchPromotions() {
      currentLocation.value = {latitude:19.4326, longitude:-99.1332}  
      if (currentLocation.value) {
            const items = await GetPromotions(currentLocation.value)
            if (items.isRight()) {
              listPromotions.value = items.get()

              isEmpty.value = listPromotions.value.length === 0

            }
        }
    }

    function GetPromotions(location) {
        return axios.get('promotions/nearby', {
          params: {
            lat: location.latitude,
            lng: location.longitude,
            radius: 5000
          },
          headers: {
            'Content-Type': 'application/json'
          }
        })
        .then(response => ({
            isRight: () => true,
            get: () => response.data || []
        }))
        .catch(error => {
            console.error('Error:', error)
            return {
              isRight: () => false,
              get: () => []
            }
        })
    }

    onMounted(() => {
       requestGeolocation()
    })

</script>

<template>
	  <div class="w-full h-[48px] flex items-center sticky top-0 bg-zinc-100 dark:bg-zinc-800 z-10"></div>
    <div v-if="listPromotions.length > 0">
        <div class="px-2 mb-4">
            <small class="text-lg block pt-2 text-gray-800/25 dark:text-white/25 pb-0 font-bold">Hola!</small>
            <label class="text-4xl pb-2 block font-bold">¿Alguna promo?</label>
            <label class="text-2xl block mb-8 font-thin">Encuentra & Aprovecha</label>
        </div>
        <h3 class="mx-3 mt-6">Promociones</h3>
        <PromotionItem
            v-for="(item, index) in listPromotions" 
            :key="index" 
            :item="item"
        />
    </div>
    <Loading
      v-else
      :isEmpty="isEmpty"
      title="Lo sentimos"
      description="No hemos encontrado ninguna promoción cercana a ti."
    />
</template>